/**
 * RT ROTAS DO SISTEMA - PARA SER USADO NA CHAMADA DO COMPONENTE
 * LK link interno da app exemplo: /cadastro/grupo/edit/654654654645-664554-645654
 * EP endpoint: "/saber/grupo/filter?search=textoparametro"
 */

import { ForbiddenPage } from '../features/aHome/ForbiddenPage';

const configUrls = {





  GRUPO_ACOMPANHAMENTO_CREATE: '/saber/cadastro/grupo/create',
  GRUPO_ACOMPANHAMENTO_EDIT: '/saber/cadastro/grupo/edit/:id',
  GRUPO_ACOMPANHAMENTO_LIST: '/saber/cadastro/grupo/list',
  GRUPO_ACOMPANHAMENTO_EDIT_LK: '/saber/cadastro/grupo/edit/',
  GRUPO_ACOMPANHAMENTO_API_EP: '/api/saber/admin/grupo',
  GRUPO_ACOMPANHAMENTO_FILTER_BY_SEARCH_EP: '/api/saber/admin/grupo/filter',

  BLOCO_CREATE: '/saber/cadastro/bloco/create',
  BLOCO_EDIT: '/saber/cadastro/bloco/edit/:id',
  BLOCO_LIST: '/saber/cadastro/bloco/list',
  BLOCO_EDIT_LK: '/saber/cadastro/bloco/edit/',
  BLOCO_API_EP: '/api/saber/admin/bloco',
  BLOCO_FILTER_BY_SEARCH_EP: '/api/saber/admin/bloco/filter',


  TIPO_PROCESSO_CREATE_RT: '/saber/cadastro/tipo-processo/create',
  TIPO_PROCESSO_EDIT_RT: '/saber/cadastro/tipo-processo/edit/:id',
  TIPO_PROCESSO_LIST_RT: '/saber/cadastro/tipo-processo/list',
  TIPO_PROCESSO_EP: '/api/saber/admin/api/saber/admin/tipo-processo',
  TIPO_PROCESSO_EDIT_LK: '/saber/cadastro/tipo-processo/edit/',

  PROCESSO_EP: '/api/saber/admin/processo',
  PROCESSO_CREATE_RT: '/saber/operacao/iniciar-processo/create',
  PROCESSO_EDIT_RT: '/saber/operacao/iniciar-processo/edit/:id',
  PROCESSO_EDIT_LK: '/saber/operacao/iniciar-processo/edit/',

  PROCESSO_FORM_VIEW: '/saber/operacao/processo/view/:id_procedimento',
  PROCESSO_FORM_VIEW_LK: '/saber/operacao/processo/view/',
  PROCESSO_LIST_RT: '/saber/operacao/processo/list',

  PROCESSO_GERAR_DOCUMENTO_EP: '/api/saber/admin/processo-documento',
  PROCESSO_GERAR_DOCUMENTO_CREATE_RT: '/saber/operacao/processo/gerar-documento/create',
  PROCESSO_GERAR_DOCUMENTO_EDIT_RT: '/saber/operacao/processo/gerar-documento/edit/:id',
  PROCESSO_GERAR_DOCUMENTO_EDIT_LK: '/saber/operacao/processo/gerar-documento/edit/',

  PROCESSO_ACOMPANHAMENTO_EP: '/api/saber/admin/processo-acompanhamento',
  PROCESSO_ACOMPANHAMENTO_CREATE_RT: '/saber/operacao/processo/gerar-acompanhamento/create',
  PROCESSO_ACOMPANHAMENTO_EDIT_RT: '/saber/operacao/processo/gerar-acompanhamento/view/:id',
  PROCESSO_ACOMPANHAMENTO_EDIT_LK: '/saber/operacao/processo/gerar-acompanhamento/view/',
  PROCESSO_ACOMPANHAMENTO_LIST_RT: '/saber/operacao/processo/gerar-acompanhamento/list',

  PROCESSO_CIENCIA_LIST: '/saber/operacao/processo/dar-ciencia/list/',

  PROCESSO_HISTORICO_CREATE_RT: '/saber/operacao/processo/historico/create/',
  PROCESSO_HISTORICO_LIST_RT: '/saber/operacao/processo/historico/list/',

  PROCESSO_ANOTACAO_CREATE_RT: '/saber/operacao/processo/anotacao/create/',
  PROCESSO_ANOTACAO_LIST_RT: '/saber/operacao/processo/anotacao/list/',
  PROCESSO_ANOTACAO_EDIT_RT: '/saber/operacao/processo/anotacao/edit/:id',
  PROCESSO_ANOTACAO_EDIT_LK: '/saber/operacao/processo/anotacao/edit/',

  PROCESSO_COMENTARIO_CREATE_RT: '/saber/operacao/processo/comentario/create/',
  PROCESSO_COMENTARIO_LIST_RT: '/saber/operacao/processo/comentario/list/',
  PROCESSO_COMENTARIO_EDIT_RT: '/saber/operacao/processo/comentario/edit/:id',
  PROCESSO_COMENTARIO_EDIT_LK: '/saber/operacao/processo/comentario/edit/',

  PROCESSO_MARCADOR_CREATE_RT: '/saber/operacao/processo/marcador/create/',
  PROCESSO_MARCADOR_LIST_RT: '/saber/operacao/processo/marcador/list/',
  PROCESSO_MARCADOR_EDIT_RT: '/saber/operacao/processo/marcador/edit/:id',
  PROCESSO_MARCADOR_EDIT_LK: '/saber/operacao/processo/marcador/edit/',

  PROCESSO_ATRIBUIR_CREATE_RT: '/saber/operacao/processo/atribuir/create/',
  PROCESSO_ATRIBUIR_LIST_RT: '/saber/operacao/processo/atribuir/list/',

  PROCESSO_BLOCO_CREATE_RT: '/saber/operacao/processo/bloco/create/',
  PROCESSO_BLOCO_LIST_RT: '/saber/operacao/processo/bloco/list/',

  PROCESSO_DOCUMENTO_VIEW: '/saber/operacao/processo-documento/view/:id',
  PROCESSO_DOCUMENTO_VIEW_LK: '/saber/operacao/processo-documento/view/',

  PROCESSO_ENVIAR_CREATE_RT: '/saber/operacao/processo/enviar/',
  PROCESSO_ENVIAR_LIST_RT: '/saber/operacao/processo/enviar/list/',

  PROCESSO_SOBRESTAR_CREATE_RT: '/saber/operacao/processo/sobrestar/',
  PROCESSO_SOBRESTAR_LIST_RT: '/saber/operacao/processo/sobrestar/list/',

  PROCESSO_CONCLUIR_CREATE_RT: '/saber/operacao/processo/concluir/',
  PROCESSO_CONCLUIR_LIST_RT: '/saber/operacao/processo/concluir/list/',

  PROCESSO_PRAZO_CREATE_RT: '/saber/operacao/processo/prazo/',
  PROCESSO_PRAZO_LIST_RT: '/saber/operacao/processo/prazo/list/',

  DOCUMENTO_EP: '/api/saber/admin/documento',
  DOCUMENTO_CIENCIA_LIST: '/saber/operacao/documento/dar-ciencia/list/:id',
  DOCUMENTO_CIENCIA_LIST_LINK: '/saber/operacao/documento/dar-ciencia/list/',

  DOCUMENTO_HISTORICO_CREATE_RT: '/saber/operacao/documento/historico/create/:id',
  DOCUMENTO_HISTORICO_CREATE_LINK: '/saber/operacao/documento/historico/create/',

  DOCUMENTO_HISTORICO_EP: '/api/saber/admin/documento-historico',
  DOCUMENTO_HISTORICO_LIST_RT: '/saber/operacao/documento/historico/list/:id',
  DOCUMENTO_HISTORICO_LIST_LINK: '/saber/operacao/documento/historico/list/',

  DOCUMENTO_FAVORITO_CREATE_RT: '/saber/operacao/documento/favorito/create/:id',
  DOCUMENTO_FAVORITO_CREATE_LINK: '/saber/operacao/documento/favorito/create/',

  
  DOCUMENTO_FAVORITO_EP: '/api/saber/admin/documento-favorito',
  DOCUMENTO_FAVORITO_LIST_RT: '/saber/operacao/documento/favorito/list/:id',
  DOCUMENTO_FAVORITO_LIST_LINK: '/saber/operacao/documento/favorito/list/',

  DOCUMENTO_EMAIL_EP: '/api/saber/admin/documento-email',
  DOCUMENTO_EMAIL_CREATE_RT: '/saber/operacao/documento/email/create/:id',
  DOCUMENTO_EMAIL_CREATE_LINK: '/saber/operacao/documento/email/create/',

  DOCUMENTO_EMAIL_LIST_RT: '/saber/operacao/documento/email/list/:id',
  DOCUMENTO_EMAIL_LIST_LINK: '/saber/operacao/documento/email/list/',

  DOCUMENTO_COMENTARIO_EP: '/api/saber/admin/documento-comentario',
  DOCUMENTO_COMENTARIO_CREATE_RT: '/saber/operacao/documento/comentario/create/:id',
  DOCUMENTO_COMENTARIO_CREATE_LINK: '/saber/operacao/documento/comentario/create/',

  DOCUMENTO_COMENTARIO_LIST_RT: '/saber/operacao/documento/comentario/list/:id',
  DOCUMENTO_COMENTARIO_LIST_LINK: '/saber/operacao/documento/comentario/list/',

  DOCUMENTO_EDITAR_EP: '/api/saber/admin/documento-editar',
  DOCUMENTO_EDITAR_RT: '/saber/operacao/processo-documento/edit/:id',
  DOCUMENTO_EDITAR_LK: '/saber/operacao/processo-documento/edit/',

  DOCUMENTO_VERSAO_EP: '/api/saber/admin/documento-versao',
  DOCUMENTO_VERSAO_LIST_RT: '/saber/operacao/documento/versao/list/:id',
  DOCUMENTO_VERSAO_LIST_LINK: '/saber/operacao/documento/versao/list/',

  DOCUMENTO_VERSAO_VIEW: '/saber/operacao/documento/view/:id/:idEdicao',
  DOCUMENTO_VERSAO_VIEW_LINK: '/saber/operacao/documento/view/',

  DOCUMENTO_ASSINAR_EP: '/api/saber/admin/documento-assinar',
  DOCUMENTO_ASSINAR_LIST_RT: '/saber/operacao/documento/assinar/list/:id',
  DOCUMENTO_ASSINAR_LIST_LINK: '/saber/operacao/documento/assinar/list/',

  DOCUMENTO_ASSINAR_RT: '/saber/operacao/documento/assinar/create/:id',
  DOCUMENTO_ASSINAR_LINK: '/saber/operacao/documento/assinar/create/',

  /**tabelas */

  TIPO_DOCUMENTO_CREATE_RT: '/saber/cadastro/tipo-documento/create',
  TIPO_DOCUMENTO_EDIT_RT: '/saber/cadastro/tipo-documento/edit/:id',
  TIPO_DOCUMENTO_LIST_RT: '/saber/cadastro/tipo-documento/list',
  TIPO_DOCUMENTO_EP: '/api/saber/admin/tipo-documento',
  TIPO_DOCUMENTO_EDIT_LK: '/saber/cadastro/tipo-documento/edit/',

  //ORGAO_CREATE: '/saber/cadastro/orgao/create',
  //ORGAO_EDIT: '/saber/cadastro/orgao/edit/:id',
  //ORGAO_LIST: '/saber/cadastro/orgao/list',
  //ORGAO_EDIT_LK: '/saber/cadastro/orgao/edit/',
  //ORGAO_FILTER_BY_SEARCH_EP: '/api/saber/admin/orgao/filter',
  //ORGAO_LOGO: '/saber/cadastro/orgao/logo',
  //ORGAO_API_EP: '/api/saber/admin/orgao',
  //ORGAO_API_EP_AXIOS: '/saber/orgao/create/axios',

  //SECRETARIA_CREATE: '/saber/cadastro/secretaria/create',
  //SECRETARIA_EDIT: '/saber/cadastro/secretaria/edit/:id',
  //SECRETARIA_LIST: '/site/cadastro/secretaria/list',
  //SECRETARIA_EDIT_LK: '/saber/cadastro/secretaria/edit/',
  //SECRETARIA_API_EP: '/api/saber/admin/secretaria',
  //SECRETARIA_FILTER_BY_SEARCH_EP: '/api/saber/admin/secretaria/filter',

  MARCADOR_EP: '/api/saber/admin/marcador',
  MARCADOR_CREATE_RT: '/saber/cadastro/marcador/create/',
  MARCADOR_LIST_RT: '/saber/cadastro/marcador/list/',
  MARCADOR_EDIT_RT: '/saber/cadastro/marcador/edit/:id',
  MARCADOR_EDIT_LK: '/saber/cadastro/marcador/edit/',

  NOT_FOUND: '/notfound',
  FORBIDDEN: '/forbidden',

  // SITE HOME

  SITE_HOME: '/site/home',
  SITE_LOGIN: '/site/login',
  SITE_LOGIN_EP: '/api/auth',



  SABER_HOME: '/saber/home',
  SABER_LOGIN: '/saber/login',

  ESCOLA_LEGISLATIVO_HOME: '/escola-legislativo/home',
  ESCOLA_LEGISLATIVO_LAYOUT: '/escola-legislativo/layout'
};

export default configUrls;
